import type {FC, ReactNode} from 'react';
import {memo} from 'react';

import MainMenuLayout from '../MainMenuLayout/MainMenuLayout';
import NotificationTopContainer from '../NotificationTopContainer/NotificationTopContainer';
import TopMenuLayout from '../TopMenuLayout/TopMenuLayout';

interface Props {
  allHeight?: boolean;
  children: ReactNode;
  customMainClass?: string;
  isWithCrumbs?: boolean;
  isWithFrom?: boolean;
  offsetMenuContainerClass?: string;
}

const MainContainerWithMenu: FC<Props> = ({
  allHeight = false,
  children,
  customMainClass = '',
  isWithCrumbs,
  isWithFrom,
  offsetMenuContainerClass = '',
}) => {
  return (
    <main className={`MainContainerWithMenuLayout ${customMainClass}`}>
      <NotificationTopContainer />

      <div className="container">
        <MainMenuLayout />
        <div
          className={`offsetMenuContainer ${
            allHeight ? 'allHeight' : ''
          } ${offsetMenuContainerClass}`}
        >
          <TopMenuLayout isWithCrumbs={isWithCrumbs} isWithFrom={isWithFrom} />
          {children}
        </div>
      </div>
    </main>
  );
};

export default memo(MainContainerWithMenu);
